webpackJsonp([96961042003272],{

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PostIcons = __webpack_require__(62);
	
	var _PostIcons2 = _interopRequireDefault(_PostIcons);
	
	var _typography = __webpack_require__(16);
	
	var _reactHelmet = __webpack_require__(87);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageTemplate = function (_Component) {
	  _inherits(PageTemplate, _Component);
	
	  function PageTemplate() {
	    _classCallCheck(this, PageTemplate);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  PageTemplate.prototype.render = function render() {
	    var siteMetadata = this.props.data.site.siteMetadata;
	    var currentPage = this.props.data.wordpressPage;
	    // console.log('------------------------------------');
	    // console.log(siteMetadata);
	    // console.log('------------------------------------');
	    return Glamor.createElement(
	      "div",
	      null,
	      Glamor.createElement(
	        _reactHelmet2.default,
	        null,
	        Glamor.createElement(
	          "title",
	          null,
	          currentPage.title + " - " + siteMetadata.title
	        ),
	        Glamor.createElement("meta", { name: "description", content: siteMetadata.description }),
	        Glamor.createElement("link", { rel: "canonical", href: "http://mysite.com/example" })
	      ),
	      Glamor.createElement("h1", { dangerouslySetInnerHTML: { __html: currentPage.title } }),
	      Glamor.createElement("div", { dangerouslySetInnerHTML: { __html: currentPage.content } })
	    );
	  };
	
	  return PageTemplate;
	}(_react.Component);
	
	exports.default = PageTemplate;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-page-js-b4c3b69edaf4eb7cdade.js